import React from 'react'
import './contact.css';
import { Card, CardBody } from 'reactstrap'
import  ContactForm from './contact-form'
import FbIcon from 'react-icons/lib/ti/social-facebook';
import TwitterIcon from 'react-icons/lib/ti/social-twitter';
import YoutubeIcon from 'react-icons/lib/ti/social-youtube';

class ContactUs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render() {
        return (
            <div style={{background:'#fafafa'}}>
                <div className="contact-us-banner">
                    <iframe title="Avitech Direction" src="https://www.google.com/maps/embed?pb=!1m26!1m12!1m3!1d247.72781253818945!2d3.3296169095758446!3d6.566412731269439!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m11!3e6!4m5!1s0x103b91f4a7f618cb%3A0xdae8fc0e72f372e6!2sAirport+Rd%2C+Lagos!3m2!1d6.567077299999999!2d3.3299035999999997!4m3!3m2!1d6.5663461!2d3.3295488!5e0!3m2!1sen!2sng!4v1531133587594" frameBorder="0" style={{border:0,width:"100%",height:"450px" }} allowFullScreen={'allowfullscreen'}></iframe>
                </div>
                <div className='contact-content'>
                    <Card style={{ marginBottom: '100px'}}>
                        <CardBody className='p-5'>


                            <div className="container">
                                <div className="row">
                                    <div className='col-md-6 p-3'>
                                        <hr style={{width:'50px',background:'rgb(220, 13, 24)',position: 'absolute',top: '-20px'}}/>
                                        <h3 className='text-uppercase pt-2 pb-2'><span>Contact Us</span></h3>
                                        <p className="pt-2">
                                            Please fill out the quick form and we will be in touch with lightning speed.
                                        </p>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className='col-md-6 pl-4 pr-2'>
                                        <div className="">
                                            <ContactForm/>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className='p-3'>
                                            <h4  className='mb-3 mt-4'>Vibranium Valley</h4>
                                            <p className='mb-5'>
                                                42 Local Airport Road, <br/>
                                                Ikeja, Lagos<br/>
                                            </p>
                                            <div>
                                                <a href="">
                                                    <FbIcon color='rgb(220, 13, 24)' size='40'/>
                                                </a>
                                                <a href="">
                                                    <TwitterIcon color='rgb(220, 13, 24)' size='40'/>
                                                </a>
                                                <a href="">
                                                    <YoutubeIcon color='rgb(220, 13, 24)' size='40'/>
                                                </a>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                         </CardBody>
                    </Card>
                </div>
            </div>
        )
    }
}
export default ContactUs



// WEBPACK FOOTER //
// ./src/views/contact-us/index.js